export const dlCheckoutStartEvent = () => {
    window.dataLayer.push({
        event: 'go_to_checkout'
    });
};
